var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{staticClass:"C-headline-publish-date"},[_vm._v("\n    "+_vm._s(_vm._f("formatDateWithTime")(_vm.date,_vm.locale))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }